<template>
<div class="yk-single-con">

    <el-form-item :label="'题目'+(index+1)" style="width:700px;">
        <Editor v-model="form.questionTitle" placeholder="请输入题干"/>
    </el-form-item>

    <el-form-item label="选项" class="yk-radioChoice">
        <el-form-item label-width="30px" v-for="(item,index) in form.radioData" :key="index">
            <el-checkbox-group v-model="form.radio" >
              <el-checkbox :label="index" @change="addCheckValue">{{alphabet[index]}}</el-checkbox>
              <div class="yk-input-show">
                <el-input v-model="form.radioData[index]" placeholder="请输入选项内容"></el-input>
              </div>
              <i class="el-icon-close" @click="closeChoice(index)"></i>
            </el-checkbox-group>
        </el-form-item>
    </el-form-item>

    <el-form-item label="添加选项">
        <el-button type="primary" @click="addChoice()">添加</el-button>
    </el-form-item>
    <el-form-item label="答案：">
      <span v-for="CheckValue in form.radio" :key="CheckValue">{{alphabet[CheckValue]}}</span>
    </el-form-item>

    <el-form-item label="解析" style="width:700px;">
        <Editor v-model="form.analysisContent" placeholder="请输入内容"/>
    </el-form-item>
    <el-form-item label="" style="width:700px;border-bottom: 1px solid silver;">
      <el-button type="primary" @click="remove()" style="float:right">删除</el-button>
    </el-form-item>
</div>
</template>

<script>
// import Vue from 'vue';
export default {
  // name: 'multiselects',
  props: {
    iSubmit: {
      type: Boolean,
      default: false
    },
    IsAnswers: {
      type: Boolean,
      default: true
    },
    sortOrder: {
      type: Number,
      default: 0
    },
    childQuestion: {
      tyoe: Object,
      default: null
    },
    showChoice: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    },
    index: {
      type: Number,
      default: 0
    }
  },
  created() {
    this.form = this.childQuestion;
  },
  data() {
    return {
      content: '请输入内容',
      formOption: {
        choice: null
      },
      a: 1,
      CheckValues: [],
      check: [],
      alphabet: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      stuAnswer: [],
      form: {
        questionTitle: '',
        radio: [], // 多选题答案
        radioData: ['', '', '', ''], // 单选与多选的框
        correctAnswer: '',
        analysisContent: '',
        sortOrder: 0,
        QuestionType: 2
      }
    };
  },
  watch: {
    iSubmit: function(val) {
      if (val) {
        this.$emit('done', {
          form: this.form
        });
      }
    },
    showChoice: function(val) {
      if (val) {
        this.form = this.childQuestion;
      } else {
        this.form ={
          questionTitle: '',
          radio: [], // 单选题题答案
          radioData: ['', '', '', ''], // 单选与多选的框
          correctAnswer: '',
          analysisContent: '',
          sortOrder: 0
        };
      }
    }
  },
  methods: {
    // 添加选项
    addChoice: function() {
      this.form.radioData.push('');
    },
    // 删除选项
    closeChoice: function(index) {
      this.form.radioData.splice(index, 1);
      this.form.radio.splice(index, 1);
    },
    // 添加正确答案
    addCheckValue: function() {
      if (this.form.radio.length <=1) {
        return;
      }
      this.form.radio.sort();
    },
    remove: function() {
      this.$emit('remove', this.index);
    }
  }
};
</script>

<style lang="scss">

.yk-single-con {
  .el-form-item .el-form-item {
    margin-bottom: 20px;
  }
  .yk-radioChoice{
    display:inline-block;
  }
  .yk-input-show {
     display:inline-block;
     width:520px;
    .el-input {
      width: 85%;
      margin-left: 15px;
    }
  }
  i.el-icon-close {
    font-size: 16px;
    margin-left: 10px;
  }

  .el-col .yk-addChoice {
    margin-left: 70px;
    color: #606266;
  }
  .yk-radioChoice {
    .yk-op-choice-child {
      margin-top: 4px;
      label,
      .yk-input-show,
      i {
        display: inline-block;
      }
      .yk-input-show {
        width: 560px;
      }
    }
  }
}
</style>

